module.exports = {
    DELETE_CUSTOMER: "Are you sure you want to delete customer?",
    DELETE_CONTACT: "Are you sure you want to delete contact?",
    DELETE_CONTACT_ADMINS: "Are you sure you want to delete this contact from admin?",
}